import * as preact from "preact";

import { type PreactPageProps } from "pages/PreactPage";

export default class UpgradedPageView extends preact.Component<PreactPageProps> {
  render() {
    return (
      <>
        <h2 class="spacing">{"\u{1f389} Congratulations! \u{1f389}"}</h2>

        <p>Welcome to Readlang Premium, you now have access to...</p>

        <ul style="list-style:disc;margin-left:20px">
          <li>An unlimited number of phrase translations</li>
          <li>Phrase translations up to 12 words long</li>
          <li>
            Unlimited{" "}
            <a href="https://blog.readlang.com/2023/06/27/z1-context-aware-explanations.html">
              Context Explanations
            </a>
          </li>
          <li>
            <a href="http://blog.readlang.com/2014/04/17/practise-words-from-specific-books.html">
              Practice Words from Specific Texts
            </a>
          </li>
          <li>
            Unlimited{" "}
            <a href="http://blog.readlang.com/2015/03/17/auto-highlight-words.html">
              Word Highlights
            </a>
          </li>
          <li>
            <a href="http://blog.readlang.com/2015/11/16/organize-your-favorite-language-learning-content-with-shelves.html">
              Shelves
            </a>
          </li>
          <li>
            <a href="http://blog.readlang.com/2015/10/06/speaking-mode.html">
              Auto-Pronounce
            </a>
          </li>
        </ul>

        <p>
          Keep your language learning enjoyable by reading what interests you.
        </p>

        <p>
          Any questions? Please get in touch at{" "}
          <a href="https://forum.readlang.com">forum.readlang.com</a>.
        </p>

        <p>
          <a href="/">Return Home</a>
        </p>
      </>
    );
  }
}
